import { useEffect } from "react";
import axios from "axios";
import { clearSession } from "../services/AuthService";

const apiUrl = process.env.REACT_APP_API_URL;

export const useAuth = () => {
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      window.location.href = "/";
      return;
    }

    axios
      .get(`${apiUrl}/verifyToken`, {
        headers: {
          auth: token,
        },
      })
      .then((response) => {
        const { status } = response.data;
        if (status !== 1) {
          clearSession();
          window.location.href = "/";
        }
      })
      .catch((error) => {
        clearSession();
        const message = error.response?.data?.message;
        if (message) {
          sessionStorage.setItem("login_message", message);
        }
        window.location.href = "/";
      });
  }, []);
};

// Use this component to wrap routes that require authentication
export const ProtectedRoute = ({ element }) => {
  useAuth();
  return element;
};
